import React, { useState, useEffect, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import webapplogo from "../assest/sidebarlogi.png";
import {
  IoPeopleOutline,
  IoBriefcaseOutline,
  IoRadioOutline,
  IoPersonOutline,
  IoLogOutOutline,
  IoChatbubbleEllipsesOutline,
} from "react-icons/io5";
import { LuLayoutDashboard } from "react-icons/lu";
import DeleteAccountSection from "./Modal/DeleteAccount";
import { IoClose } from "react-icons/io5";
import Offcanvas from "react-bootstrap/Offcanvas";

function SidebarOffCanvas({ name = "Sidebar", show, setShow }) {
  const handleClose = () => setShow(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState("");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const menuItems = useMemo(
    () => [
      {
        title: "Overview",
        icon: <LuLayoutDashboard size={24} />,
        path: "/dashboard/overview",
      },
      {
        title: "My Campaigns",
        icon: <IoRadioOutline size={24} />,
        path: "/dashboard/my-campaigns",
      },
      {
        title: "Conversations",
        icon: <IoChatbubbleEllipsesOutline size={24} />,
        path: "/dashboard/conversations",
      },
      {
        title: "Target Users",
        icon: <IoPeopleOutline size={24} />,
        path: "/dashboard/target-users",
      },
      {
        title: "My Organization",
        icon: <IoBriefcaseOutline size={24} />,
        path: "/myorganization",
      },
      {
        title: "My Profile",
        icon: <IoPersonOutline size={24} />,
        path: "/profile",
      },
    ],
    []
  );

  const HandleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("organizationid");
    localStorage.removeItem("version");
    localStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const currentItem = menuItems.find((item) => item.path === currentPath);
    if (currentItem) {
      setSelected(currentItem.title);
    }
  }, [location.pathname, menuItems]);

  return (
    <>
      <aside className="sidebar d-none d-lg-block pb-4">
        <div className="space-y-2 mb-[80px]">
          <div className="logo">
            <img src={webapplogo} alt="Logo" />
          </div>
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              onClick={() => setSelected(item.title)}
              className={`flex items-center gap-3 text-decoration-none font-medium px-4 py-3 ${
                selected === item.title
                  ? "w-[90%] bg-red-500 text-white rounded-r-full"
                  : "text-black"
              } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
            >
              {item.icon}
              <span className="w-full text-decoration-none">{item.title}</span>
            </Link>
          ))}
        </div>

        <div className=" ">
          {/* <Link
            to='/myorganization'
            onClick={() => setSelected("My Organization")}
            className={`flex items-center gap-3 text-decoration-none font-medium px-4 py-3 ${
              selected === "My Organization"
                ? "w-[90%] bg-red-500 text-white rounded-r-full"
                : "text-black"
            } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
          >
            <IoBriefcaseOutline size={24} />
            <span className='w-full text-decoration-none'>My Organization</span>
          </Link>

          <Link
            to='/profile'
            onClick={() => setSelected("My Profile")}
            className={`flex items-center gap-3 text-decoration-none font-medium px-4 py-3 ${
              selected === "My Profile"
                ? "w-[90%] bg-red-500 text-white rounded-r-full"
                : "text-black"
            } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
          >
            <IoPersonOutline size={24} />
            <span className='w-full'>My Profile</span>
          </Link> */}

          <div
            className={`flex items-center gap-3 font-medium px-4 py-3 border-0 bg-red hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full cursor-pointer`}
          >
            <IoLogOutOutline size={24} />
            <span onClick={HandleLogout} className="w-full">
              LogOut
            </span>
          </div>
        </div>

        {isDeleteModalVisible && (
          <DeleteAccountSection
            visible={isDeleteModalVisible}
            onClose={() => setIsDeleteModalVisible(false)}
          />
        )}
      </aside>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Body>
          <aside className="sidebar pb-4 position-relative">
            <button
              onClick={handleClose}
              className="position-absolute bg-transparent border border-0 right-2"
            >
              <IoClose size={24} />
            </button>
            <div className="space-y-2">
              <div className="logo">
                <img src={webapplogo} alt="Logo" />
              </div>
              {menuItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  onClick={() => setSelected(item.title)}
                  className={`flex items-center gap-3 text-decoration-none font-medium px-4 py-3 ${
                    selected === item.title
                      ? "w-[90%] bg-red-500 text-white rounded-r-full"
                      : "text-black"
                  } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
                >
                  {item.icon}
                  <span className="w-full text-decoration-none">
                    {item.title}
                  </span>
                </Link>
              ))}
            </div>

            <div className="space-y-2 mb-28">
              {/* <Link
                to='/myorganization'
                onClick={() => setSelected("My Organization")}
                className={`flex items-center gap-3 text-decoration-none font-medium px-4 py-3 ${
                  selected === "My Organization"
                    ? "w-[90%] bg-red-500 text-white rounded-r-full"
                    : "text-black"
                } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
              >
                <IoBriefcaseOutline size={24} />
                <span className='w-full text-decoration-none'>
                  My Organization
                </span>
              </Link>

              <Link
                to='/profile'
                onClick={() => setSelected("My Profile")}
                className={`flex items-center gap-3 text-decoration-none font-medium px-4 py-3 ${
                  selected === "My Profile"
                    ? "w-[90%] bg-red-500 text-white rounded-r-full"
                    : "text-black"
                } hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full`}
              >
                <IoPersonOutline size={24} />
                <span className='w-full'>My Profile</span>
              </Link> */}

              <div
                className={`flex items-center gap-3 font-medium px-4 py-3 border-0 bg-red hover:bg-red-500 hover:text-white hover:w-[90%] rounded-r-full cursor-pointer`}
              >
                <IoLogOutOutline size={24} />
                <span onClick={HandleLogout} className="w-full">
                  LogOut
                </span>
              </div>
            </div>

            {isDeleteModalVisible && (
              <DeleteAccountSection
                visible={isDeleteModalVisible}
                onClose={() => setIsDeleteModalVisible(false)}
              />
            )}
          </aside>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SidebarOffCanvas;
